import PropTypes from "prop-types";

export const userObject = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  Name: PropTypes.string.isRequired,
  Kind: PropTypes.string.isRequired,
  Permissions: PropTypes.arrayOf(PropTypes.string),
  Roles: PropTypes.string
});
